import { useAccountCompanyId } from 'application/hooks';
import { toast } from '@shared/ui';
import { RouterUtils } from 'application/providers/RouterProvider';
import AnalyticsService, { EventNameAMP } from 'application/services/AnalyticsService';
import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import { buildAbsoluteUrl } from '@shared/lib';
import { BILLING_PAGE_PATH, StateParamValues } from '@entities/billing';
import useBindCard from '@entities/paymentMethod/api/useBindCard';

interface UseCardBindModal {
  bindCardLoading: boolean;
  bindCardConfirm: () => Promise<void>;
}

const useCardBindModal = (): UseCardBindModal => {
  const companyId = useAccountCompanyId();

  const { request: getLinkForBindingCard, result: bindCardResult } = useBindCard();

  const pathname = RouterUtils.generatePath(BILLING_PAGE_PATH, { state: StateParamValues.INFO });

  const bindCardConfirm = async () => {
    const link = await getLinkForBindingCard(buildAbsoluteUrl(pathname), companyId);

    AnalyticsService.event(EventNameAMP.BIND_CARD_PRESSED);

    if (link) {
      window.location.assign(link);
    } else {
      toast.error(TEXTS.BILLING_BIND_CARD_NOTIFICATION_ERROR_MESSAGE);
    }
  };

  return {
    bindCardLoading: bindCardResult.loading,
    bindCardConfirm,
  };
};

export default useCardBindModal;
